'use client';

export { useAnalyticsService } from './useAnalyticsService';
export { useAnalyticsEvent } from './useAnalyticsEvent';
export type { AnalyticsPlatformContext } from './useAnalyticsEvent';
export {
  mapAttributionParamsToAnalyticsContext,
  parseAnalyticsAttributionFromUrl,
  resolvePersistedAnalyticsAttribution,
} from './analyticsAttribution';
export type {
  AnalyticsAttributionContext,
  AnalyticsAttributionParamKey,
  AnalyticsAttributionParams,
} from './analyticsAttribution';
export { trackPdpInteraction } from './pdpInteraction';
export type { PdpInteractionAction } from './pdpInteraction';
export {
  trackBannerClicked,
  trackNavigationClicked,
  trackWishlistClicked,
  trackContactLinkClicked,
  trackReviewInteraction,
  trackFilterApplied,
  trackViewCart,
  trackSearchResultsViewed,
  trackViewItemList,
  trackProgressBarInteraction,
  trackEngagementThresholdReached,
} from './frontInteractionEvents';
export type {
  BannerClickedParams,
  NavigationItem,
  NavigationClickedParams,
  WishlistAction,
  ContactType,
  ReviewAction,
  FilterType,
  FilterAppliedParams,
  ViewCartParams,
  SearchResultsViewedParams,
  ViewItemListParams,
  ProgressBarAction,
  ProgressBarParams,
  EngagementThresholdParams,
} from './frontInteractionEvents';
export {
  reviewEventBaseParams,
  trackReviewSectionViewed,
  trackReviewTabClicked,
  trackReviewSectionDwell,
  trackReviewFilterUsed,
  trackReviewCardExpanded,
  trackReviewImageSwiped,
  trackLoadMoreReviews,
  trackAiSummaryViewed,
  trackAiSummaryRead,
  trackAiInsightCardSwiped,
  trackAiSummaryHelpfulVote,
} from './reviewSectionEvents';
export type {
  ReviewBlock,
  ReviewEventBase,
  ReviewSectionEntry,
  ReviewFilterType,
  AiSummaryReadSignal,
  AiInsightGroup,
  AiSummaryVote,
} from './reviewSectionEvents';
